import { LoadingStatusType, TaxDocumentType, TypeComponentNoti } from "@/enums/enums";
import { SetAlertAddFileStorage } from "@/helper/uploadHelper";
import { i18n } from "@/i18n";
import API from "@/service/Index";
import { ConvertToFileStoragePnd } from "@/service/pnd/pndFacade";
import { ConvertToFileStoragePP30 } from "@/service/pp30/pp30Facade";
import {
  ConvertToCommentLogWhtCertificate,
  ConvertToFileStorageWhtCertificate,
} from "@/service/withholding/withholdingFacade";
import { filter } from "vue/types/umd";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from "..";

@Module({ namespaced: true })
export default class Upload extends VuexModule {
  public fileStorageLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public fileStorage: any = [];
  public addFileStorageLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public voidFileStorageLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  get getFileStorageLoadingStatus(): LoadingStatusType {
    return this.fileStorageLoadingStatus;
  }
  get getFileStorage(): any {
    return this.fileStorage;
  }
  get getAddFileStorageLoadingStatus(): LoadingStatusType {
    return this.addFileStorageLoadingStatus;
  }
  get getVoidFileStorageLoadingStatus(): LoadingStatusType {
    return this.voidFileStorageLoadingStatus;
  }

  @Mutation
  public SetFileStorageLoadingStatus(status: LoadingStatusType) {
    this.fileStorageLoadingStatus = status;
  }
  @Mutation
  public SetFileStorage(fileStorage: any) {
    this.fileStorage = fileStorage;
  }
  @Mutation
  public SetAddFileStorageLoadingStatus(status: LoadingStatusType) {
    this.addFileStorageLoadingStatus = status;
  }
  @Mutation
  public SetVoidFileStorageLoadingStatus(status: LoadingStatusType) {
    this.voidFileStorageLoadingStatus = status;
  }

  @Action
  public DoGetFileStorage(input: any) {
    if (this.fileStorageLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetFileStorageLoadingStatus", LoadingStatusType.Loading);
      switch (input.taxDocumentType) {
        case TaxDocumentType.WithHoldingTax: {
          API.WithholdingService.GetFileStorageWhtCertificate(input.id).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              const fileStorageWhtCertificate = ConvertToFileStorageWhtCertificate(res.data.data);
              this.context.commit("SetFileStorage", fileStorageWhtCertificate);
            }
            this.context.commit("SetFileStorageLoadingStatus", LoadingStatusType.Success);
          });
          break;
        }
        case TaxDocumentType.Pnd: {
          API.PndService.GetFileStoragePnd(input.id).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              const fileStoragePnd = ConvertToFileStoragePnd(res.data.data);
              this.context.commit("SetFileStorage", fileStoragePnd);
            }
            this.context.commit("SetFileStorageLoadingStatus", LoadingStatusType.Success);
          });
          break;
        }
        case TaxDocumentType.PP30Transaction: {
          API.PP30Service.GetFileStoragePP30Transaction(input.id).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              const fileStoragePP30 = ConvertToFileStoragePP30(res.data.data);
              this.context.commit("SetFileStorage", fileStoragePP30);
            }
            this.context.commit("SetFileStorageLoadingStatus", LoadingStatusType.Success);
          });
          break;
        }
        case TaxDocumentType.PP30Form: {
          API.PP30Service.GetFileStoragePP30Form(input.id).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              const fileStoragePP30 = ConvertToFileStoragePP30(res.data.data);
              this.context.commit("SetFileStorage", fileStoragePP30);
            }
            this.context.commit("SetFileStorageLoadingStatus", LoadingStatusType.Success);
          });
          break;
        }
      }
    }
  }
  @Action
  public DoAddFileStorage(input: any) {
    if (this.addFileStorageLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetAddFileStorageLoadingStatus", LoadingStatusType.Loading);
      const idNoificition = new Date().getTime();
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          id: idNoificition,
          typeUpload: "Start",
          typeMessage: TypeComponentNoti.Upload,
        },
        { root: true }
      );
      switch (input.taxDocumentType) {
        case TaxDocumentType.WithHoldingTax: {
          API.WithholdingService.AddFileStorageWhtCertificate(input.fileList).then((res) => {
            const responseSuccess: any = [];
            const responseError: any = [];
            if (res && res.length > 0) {
              res.forEach((resItem: any) => {
                if (resItem.data.responseCode.IsSuccess()) {
                  responseSuccess.push(resItem);
                } else {
                  responseError.push(resItem);
                }
              });
            }
            if (responseSuccess && responseSuccess.length > 0) {
              SetAlertAddFileStorage(responseSuccess, true, idNoificition, input);
            } else if (responseError && responseError.length > 0) {
              SetAlertAddFileStorage(responseError, false, idNoificition, input);
            }
            this.context.commit("SetAddFileStorageLoadingStatus", LoadingStatusType.Success);
          });
          break;
        }
        case TaxDocumentType.Pnd: {
          API.PndService.AddFileStoragePnd(input.fileList).then((res) => {
            const responseSuccess: any = [];
            const responseError: any = [];
            if (res && res.length > 0) {
              res.forEach((resItem: any) => {
                if (resItem.data.responseCode.IsSuccess()) {
                  responseSuccess.push(resItem);
                } else {
                  responseError.push(resItem);
                }
              });
            }
            if (responseSuccess && responseSuccess.length > 0) {
              SetAlertAddFileStorage(responseSuccess, true, idNoificition, input);
            } else if (responseError && responseError.length > 0) {
              SetAlertAddFileStorage(responseError, false, idNoificition, input);
            }
            this.context.commit("SetAddFileStorageLoadingStatus", LoadingStatusType.Success);
          });
          break;
        }
        case TaxDocumentType.PP30Transaction: {
          API.PP30Service.AddFileStoragePP30Transaction(input.fileList).then((res) => {
            const responseSuccess: any = [];
            const responseError: any = [];
            if (res && res.length > 0) {
              res.forEach((resItem: any) => {
                if (resItem.data.responseCode.IsSuccess()) {
                  responseSuccess.push(resItem);
                } else {
                  responseError.push(resItem);
                }
              });
            }
            if (responseSuccess && responseSuccess.length > 0) {
              SetAlertAddFileStorage(responseSuccess, true, idNoificition, input);
            } else if (responseError && responseError.length > 0) {
              SetAlertAddFileStorage(responseError, false, idNoificition, input);
            }
            this.context.commit("SetAddFileStorageLoadingStatus", LoadingStatusType.Success);
          });
          break;
        }
        case TaxDocumentType.PP30Form: {
          API.PP30Service.AddFileStoragePP30Form(input.fileList).then((res) => {
            const responseSuccess: any = [];
            const responseError: any = [];
            if (res && res.length > 0) {
              res.forEach((resItem: any) => {
                if (resItem.data.responseCode.IsSuccess()) {
                  responseSuccess.push(resItem);
                } else {
                  responseError.push(resItem);
                }
              });
            }
            if (responseSuccess && responseSuccess.length > 0) {
              SetAlertAddFileStorage(responseSuccess, true, idNoificition, input);
            } else if (responseError && responseError.length > 0) {
              SetAlertAddFileStorage(responseError, false, idNoificition, input);
            }
            this.context.commit("SetAddFileStorageLoadingStatus", LoadingStatusType.Success);
          });
          break;
        }
      }
    }
  }
  @Action
  public DoVoidFileStorage(input: any) {
    if (this.fileStorageLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetVoidFileStorageLoadingStatus", LoadingStatusType.Loading);
      switch (input.taxDocumentType) {
        case TaxDocumentType.WithHoldingTax: {
          API.WithholdingService.VoidFileStorageWhtCertificate(input.file).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Delete_File_Success", { msg: input.file.fileName }),
                  typeMessage: TypeComponentNoti.Success,
                },
                { root: true }
              );
            } else {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Delete_File_Fail", { msg: input.file.fileName }),
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
            }
            this.context.commit("SetVoidFileStorageLoadingStatus", LoadingStatusType.Success);
          });
          break;
        }
        case TaxDocumentType.Pnd: {
          API.PndService.VoidFileStoragePnd(input.file).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Delete_File_Success", { msg: input.file.fileName }),
                  typeMessage: TypeComponentNoti.Success,
                },
                { root: true }
              );
            } else {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Delete_File_Fail", { msg: input.file.fileName }),
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
            }
            this.context.commit("SetVoidFileStorageLoadingStatus", LoadingStatusType.Success);
          });
          break;
        }
        case TaxDocumentType.PP30Transaction: {
          API.PP30Service.VoidFileStoragePP30Transaction(input.file).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Delete_File_Success", { msg: input.file.fileName }),
                  typeMessage: TypeComponentNoti.Success,
                },
                { root: true }
              );
            } else {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Delete_File_Fail", { msg: input.file.fileName }),
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
            }
            this.context.commit("SetVoidFileStorageLoadingStatus", LoadingStatusType.Success);
          });
          break;
        }
        case TaxDocumentType.PP30Form: {
          API.PP30Service.VoidFileStoragePP30Form(input.file).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Delete_File_Success", { msg: input.file.fileName }),
                  typeMessage: TypeComponentNoti.Success,
                },
                { root: true }
              );
            } else {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Delete_File_Fail", { msg: input.file.fileName }),
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
            }
            this.context.commit("SetVoidFileStorageLoadingStatus", LoadingStatusType.Success);
          });
          break;
        }
      }
    }
  }
}
